import { IMSAggregator } from './aggregator';
import { min } from 'app/shared/aggregators';
/**
 * @ngdoc service
 * @name ims.viewControllers.service:MinAggregator
 * @description
 * The MinAggregator is a service that returns the minimum of an array of stats or values.
 */

export class MinAggregator extends IMSAggregator {
    constructor() {
        super();
        this.logicalName = 'min';
        this.displayName = 'Minimum';
    }

    /**
     * Takes in an array of values and returns an aggregate value.
     * Returns the min of the value array.
     *
     * @param valueArray An array of values
     * @returns Number number or string value
     */
    getAggValueForValueArray(valueArray) {
        return min(valueArray);
    }
}
